
import { bindable } from 'aurelia';
import { EventEntity } from '../../apis/event/event-entity';

export class InfoPresenter {

    @bindable public event: EventEntity = null;

    public get title(): string {
        return this.event != null ? this.event.title : '';
    }

    public get organizer(): string {
        return this.event != null ? this.event.organizer : '';
    }

    public get location(): string {
        return this.event != null ? this.event.location :  '';
    }

    public get description(): string {
        return this.event != null ? this.event.description : '';
    }

    public get startDate(): string {
        return this.event != null ? this.event.startDate.toString() : null;
    }

    public get endDate(): string {
        return this.event != null && this.event.endDate != null ? this.event.endDate.toString() : null;
    }

    public get isMultiDay(): boolean {
        return this.event != null && this.event.endDate != null && this.event.endDate.isAfter(this.event.startDate);
    }

    public get hasCoordinates(): boolean {
        return this.event != null && this.event.latitude != null && this.event.longitude != null;
    }

    public get mapsUrl(): string {
        if (!this.hasCoordinates) return null;
        return `https://maps.google.com/maps?q=${this.event.latitude},${this.event.longitude}`;
    }
}
